<template>
  <div v-if="isShowContent">
    <div class="ccui-app-container-detail2">
      <div class="ccui-app-container-detail-body">
        <div class="ccui-top-title">基本信息</div>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="160px"
          class="ccui-form"
        >
          <el-form-item label="公司名称：">
            {{ form.businessName }}
          </el-form-item>
          <el-form-item label="公司简称：" prop="businessShortname">
            <el-input
              clearable
              v-model.trim="form.businessShortname"
              class="input-long"
              placeholder="请输入公司简称"
              :disabled="canEdit"
              maxlength="30"
            />
          </el-form-item>
          <el-form-item label="统一社会信用代码：" prop="unifiedCode">
            <span style="position: absolute; left: -127px; color: #f56c6c"
              >*</span
            >
            <el-input
              clearable
              v-model.trim="form.unifiedCode"
              @input="creditCodeChange"
              class="input-long"
              placeholder="请输入统一社会信用代码"
              maxlength="18"
            />
          </el-form-item>
          <el-form-item label="住所：" prop="address">
            <el-input
              maxlength="200"
              clearable
              @blur="allStrTrim('address')"
              v-model="form.address"
              class="input-long"
              placeholder="请输入住所"
            />
          </el-form-item>
          <el-form-item label="注册资本（万元）：" prop="regCapl">
            <el-input
              clearable
              maxlength="15"
              v-model.trim="form.regCapl"
              @input="regNumber('regCapl')"
              class="input-long"
              placeholder="请输入注册资本（万元）"
            />
          </el-form-item>
          <el-form-item label="实收资本（万元）：" prop="factCapl">
            <el-input
              maxlength="15"
              clearable
              v-model.trim="form.factCapl"
              @input="regNumber('factCapl')"
              class="input-long"
              placeholder="请输入实收资本（万元）"
            />
          </el-form-item>
          <el-form-item label="公司类型：" prop="compType">
            <el-select
              clearable
              v-model.trim="form.compType"
              class="input-long"
              placeholder="请选择公司类型"
            >
              <el-option
                v-for="(item, idx) in codeList"
                :value="item.dicKey"
                :label="item.dicValue"
                :key="idx"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="成立时间：" prop="regTime">
            <el-date-picker
              :picker-options="pickerOptions"
              v-model.trim="form.regTime"
              class="input-long"
              value-format="yyyy-MM-dd"
              clearable
              type="date"
              placeholder="请选择成立时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="所在区域："
            prop="locationquyu"
            :class="
              defaultSelectCascader !== '请选择所在区域' ? 'checkClass' : ''
            "
          >
            <el-cascader
              ref="addressSel"
              v-model.trim="form.locationquyu"
              class="input-long"
              :options="options"
              :placeholder="defaultSelectCascader"
              :props="elCascader"
              @change="cascaderChange"
            >
            </el-cascader>
            <i
              class="el-icon-circle-close icon-delete"
              @click="iconClearPhander()"
            ></i>
          </el-form-item>
          <el-form-item label="单位类别：" prop="compClass">
            <el-select
              v-model.trim="form.compClass"
              class="input-long"
              clearable
              placeholder="请选择单位类别"
            >
              <el-option
                v-for="(item, idx) in COMPCLASSList"
                :value="item.dicKey"
                :label="item.dicValue"
                :key="idx"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="办公地址：" prop="officeAddress">
            <el-input
              maxlength="200"
              clearable
              @blur="allStrTrim('officeAddress')"
              v-model="form.officeAddress"
              class="input-long"
              placeholder="请输入办公地址"
            />
          </el-form-item>
          <el-form-item label="纳税人类型：" prop="taxpayerId">
            <el-select
              clearable
              v-model.trim="form.taxpayerId"
              class="input-long"
              placeholder="请选择纳税人类型"
              value=""
            >
              <el-option
                v-for="(item, idx) in taxerList"
                :value="item.dicKey"
                :label="item.dicValue"
                :key="idx"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="经营范围：" prop="businessScope">
            <el-input
              maxlength="2000"
              clearable
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              class="input-long"
              @blur="allStrTrim('businessScope')"
              placeholder="请输入经营范围"
              v-model="form.businessScope"
            />
          </el-form-item>
          <el-form-item label="公司联系电话：" prop="businessTelephone">
            <el-input
              maxlength="30"
              clearable
              @input="regSpace('businessTelephone')"
              v-model.trim="form.businessTelephone"
              class="input-long"
              placeholder="请输入公司联系电话"
            />
          </el-form-item>
          <div class="ccui-top-title">法定代表人</div>
          <div style="height: 20px"></div>
          <el-form-item label="姓名：" prop="legalPerson">
            <el-input
              maxlength="50"
              clearable
              @blur="allStrTrim('legalPerson')"
              v-model="form.legalPerson"
              class="input-long"
              placeholder="请输入法定代表人姓名"
            />
          </el-form-item>
          <el-form-item label="证件类型：">
            <el-input v-model="typename" readonly class="input-long" />
          </el-form-item>
          <el-form-item label="证件号码：" prop="idNum">
            <el-input
              maxlength="18"
              clearable
              @input="regSpace('idNum')"
              v-model.trim="form.idNum"
              class="input-long"
              placeholder="请输入证件号码"
            />
          </el-form-item>
          <div class="ccui-top-title">财务信息</div>
          <div style="height: 20px"></div>
          <el-form-item label="开户银行：" prop="depositBank">
            <el-input
              maxlength="200"
              clearable
              @blur="allStrTrim('depositBank')"
              v-model="form.depositBank"
              class="input-long"
              placeholder="请输入开户银行"
            />
          </el-form-item>
          <el-form-item label="银行账号：" prop="bankNum">
            <el-input
              maxlength="25"
              clearable
              @input="regNumber('bankNum')"
              v-model.trim="form.bankNum"
              class="input-long"
              placeholder="请输入银行账号"
            />
          </el-form-item>
          <el-form-item label="开票地址：" prop="billAddress">
            <el-input
              maxlength="200"
              clearable
              @blur="allStrTrim('billAddress')"
              v-model="form.billAddress"
              class="input-long"
              placeholder="请输入开票地址"
            />
          </el-form-item>
          <el-form-item label="开票电话：" prop="billPhone">
            <el-input
              maxlength="30"
              @input="regSpace('billPhone')"
              clearable
              v-model.trim="form.billPhone"
              class="input-long"
              placeholder="请输入开票电话"
            />
          </el-form-item>
        </el-form>
        <div class="ccui-top-title">企业资质</div>
        <span class="file-type-lyp"
          >上传文件支持格式：.jpg .png .jpeg .gif每个不超过5M，.xls .xlsx .doc
          .docx .pdf每个不超过15M</span
        >
        <upload-template
          v-if="isDefaultImg"
          :thisPage="thisPageName"
          v-for="(item, idx) in titleData"
          :key="idx"
          ref="uploadTemplate"
          :titleData="item"
          :isMarginIdx="idx"
        />

        <div class="footer-step-lyp">
          <div class="step-right-lyp" @click="nextClick">下一步</div>
        </div>
        <div style="height: 20px"></div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="showInfoModal"
      width="380px"
      class="dialog-center"
      show-divider
      show-shadow
      :before-close="handleClose"
      custom-class="el-dialog--customize"
    >
      <span>{{ showInfoContent }}</span>
      <span slot="footer">
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="showInfoModal = false"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validators from "@/utils/validators";
import Cookies from "js-cookie";
import uploadTemplate from ".././components/upload-template.vue";
import {
  getQryByBusName,
  getQryBusinessInfoByTyc,
  getQryDictByCode,
  getQryByCode,
  getAddBusinessInfo,
  getQryBusinessInfo,
} from "@/api/input-business-info.js";
// import { _deepClone } from '@/utils/validate.js'
export default {
  name: "inputBusinessInfo",
  components: {
    uploadTemplate,
  },
  data() {
    return {
      shopCode: "",
      typename: "身份证",
      showInfoContent:
        "商家信息已存在，可对信息进行修改，开店审批通过后商家信息将会更新，为平台共享信息。",
      showInfoModal: false,
      thisPageName: "inputBusinessInfo",
      dialogVisible: false,
      isDefaultImg: true,
      uploadIsCheck: "check",
      titleData: [
        {
          name: "营业执照",
          isDefault: 1,
          isDateInput: true,
          isShowDateInput: true,
        },
        {
          name: "税务登记证",
          isDefault: 1,
          isShowDateInput: true,
        },
        {
          name: "银行开户行许可证",
          isDefault: 1,
          isShowDateInput: false,
        },
        {
          name: "法定代表人身份证",
          isDefault: 1,
          isShowDateInput: false,
        },
      ],
      titleData2: [
        {
          name: "纳税人证明材料",
          isDefault: 1,
          isShowDateInput: false,
        },
        {
          name: "税务登记证",
          isDefault: 1,
          isShowDateInput: false,
        },
        {
          name: "组织机构代码证",
          isDefault: 1,
          isShowDateInput: true,
          isDateInput: true,
        },
      ],
      form: {
        businessName: "",
        businessShortname: "",
        unifiedCode: "",
        regNum: "",
        orgCode: "",
        taxCode: "",
        address: "",
        regCapl: "",
        factCapl: "",
        compType: "",
        regTime: "",
        locationquyu: "",
        compClass: "",
        officeAddress: "",
        taxpayerId: "",
        businessScope: "",
        businessTelephone: "",
        legalPerson: "",
        idType: "1",
        idNum: "",
        depositBank: "",
        bankNum: "",
        billAddress: "",
        billPhone: "",
        province: "",
        provinceName: "",
        city: "",
        cityName: "",
        county: "",
        countyName: "",
      },
      isRules: ["regNum", "orgCode", "taxCode"],
      rules: {
        bankNum: [
          { required: true, message: "请输入银行账号", trigger: "blur" },
        ],
        depositBank: [
          { required: true, message: "请输入开户银行", trigger: "blur" },
        ],
        idNum: [{ required: true, message: "请输入证件号码", trigger: "blur" }],
        // idType: [
        //   { required: true, message: '请选择', trigger: 'change' }
        // ],
        legalPerson: [
          { required: true, message: "请输入法定代表人姓名", trigger: "blur" },
          {
            // pattern:/^[\u4e00-\u9fa5A-Za-z\s\·\(\)\（\）]+$/,
            // message: '请正确填写法定代表人姓名',
            pattern: /^((?!.*(&)).)*$/,
            message: "不可输入&",
            trigger: "blur",
          },
        ],
        businessTelephone: [
          { required: true, message: "请输入公司联系电话", trigger: "blur" },
          {
            validator: validators.minMobile,
            message: "请输入正确格式的电话",
            trigger: "blur",
          },
        ],
        billPhone: [
          {
            validator: validators.minMobile,
            message: "请输入正确格式的电话",
            trigger: "blur",
          },
        ],
        businessScope: [
          { required: true, message: "请输入经营范围", trigger: "blur" },
        ],
        taxpayerId: [
          { required: true, message: "请选择纳税人类型", trigger: "change" },
        ],
        officeAddress: [
          { required: true, message: "请输入办公地址", trigger: "blur" },
        ],
        compClass: [
          { required: true, message: "请选择单位类别", trigger: "change" },
        ],
        locationquyu: [
          { required: true, message: "请选择所在区域", trigger: "change" },
        ],
        regTime: [
          { required: true, message: "请选择成立时间", trigger: "blur" },
        ],
        compType: [
          { required: true, message: "请输入公司类型", trigger: "change" },
        ],
        regCapl: [
          { required: true, message: "请输入注册资本", trigger: "blur" },
          {
            pattern: /(^[1-9]\d{0,15}\.?\d{0,4}$)|(^0\.\d{0,4}$)/,
            // // pattern:/^\d{1,10}(\.\d{0,4})?$/,
            message: "请正确输入注册资本（小数点0-4位）",

            // pattern: /^\d+$|^\d*\.\d+$/g,
            // message: '请正确输入注册资本',
            trigger: "blur",
          },
        ],
        factCapl: [
          // { required: true, message: '请输入实收资本', trigger: 'blur' },
          {
            pattern: /^\d+$|^\d*\.\d+$/g,
            message: "请正确输入实收资本",
            trigger: "blur",
          },
        ],
        address: [{ required: true, message: "请输入住所", trigger: "blur" }],
        unifiedCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur",
          },
          {
            pattern: /^[0-9A-HJ-NPQRTUWXY]+$/,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur",
          },
          {
            max: 18,
            min: 18,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur",
          },
        ],
        businessName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        businessShortname: [
          { required: true, message: "请输入公司简称", trigger: "blur" },
        ],
        regNum: [
          { required: true, message: "请输入工商注册号", trigger: "blur" },
        ],
        orgCode: [
          { required: true, message: "请输入组织机构代码", trigger: "blur" },
          {
            pattern: /^[0-9A-HJ-NPQRTUWXY]{0,9}$/,
            message: "请输入正确的组织机构代码",
            trigger: "blur",
          },
        ],
        taxCode: [
          { required: true, message: "请输入纳税人识别号", trigger: "blur" },
          {
            pattern: /^[0-9A-HJ-NPQRTUWXY]*$/,
            message: "请输入正确的纳税人识别号",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入电话", trigger: "blur" },
          {
            validator: validators.mobile,
            message: "请输入正确格式的电话",
            trigger: "blur",
          },
        ],
      },
      options: [],
      isInputCode: true,
      taxerList: [],
      codeList: [],
      moneyList: [],
      COMPCLASSList: [],
      IDList: [],
      elCascader: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          console.log(node, "sdf");
          if (node.level !== 0) {
            this.getQryByCode(node.data.code, resolve);
          } else {
            resolve([]);
          }
        },
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      keepAlive: [
        "business-shop-business-shop-children-apply-shop-input-business-info",
        "business-shop-business-shop-children-apply-shop-input-business-name",
        "business-shop-business-shop-children-apply-shop-input-business-info",
      ],
      isShowContent: true,
      cascaderArr: [
        {
          code: "province",
          name: "provinceName",
        },
        {
          code: "city",
          name: "cityName",
        },
        {
          code: "county",
          name: "countyName",
        },
      ],
      defaultSelectCascader: "请选择所在区域",
      contactId: "",
      businessId: "",
      canEdit: false,
    };
  },
  computed: {
    reload() {
      return this.$store.state.app.reload;
    },
  },
  mounted() {
    this.mountedFn();
    this.$store.commit("ADD_CACHED_VIEW", { name: "inputBusinessInfo" });
  },
  destroyed() {
    this.deleteLoad();
  },
  beforeRouteLeave(to, from, next) {
    this.deleteLoad();
    next();
  },
  activated() {
    // this.$store.commit("DEL_CACHED_VIEW", { name: 'inputBusinessInfo' });
  },
  methods: {
    iconClearPhander() {
      this.defaultSelectCascader = "请选择所在区域";
      this.form.locationquyu = "";
    },
    handleClose(done) {
      done();
    },
    allStrTrim(key) {
      this.form[key] = this.form[key].trim();
    },

    copyInfoByTc(target, obj) {
      this.copyObj(target, obj);
      target.address = obj.regLocation;
      target.taxCode = obj.taxNumber;
      target.businessScope = obj.supplierScope;
      target.unifiedCode = obj.creditCode;
      target.regTime = obj.foundTime;
      target.businessShortname = obj.businessShortName;
      this.clearCheck("default");
      if (target.unifiedCode) {
        this.uploadIsCheck = "no";
        this.$eventBus.$emit("isCheckFile", "no");
      } else {
        this.uploadIsCheck = "check";
        this.$eventBus.$emit("isCheckFile", "check");
      }
    },
    regNumInput() {
      this.regNumber("regNum");
      this.clearCheck();
    },
    copyObj(target, obj) {
      for (let key in obj) {
        for (let targetKey in target) {
          if (key === targetKey) {
            target[targetKey] = obj[key];
          }
        }
      }
    },
    copyBasicInfo(target, obj) {
      this.copyObj(target, obj);
      let bfalse = false;
      for (let i = 0; i < this.cascaderArr.length; i++) {
        if (obj[this.cascaderArr[i].code]) {
          bfalse = true;
          break;
        }
      }
      if (bfalse) {
        let str = "";
        if (!obj.cityName) {
          str = obj.provinceName;
        } else {
          str =
            obj.provinceName + " / " + obj.cityName + " / " + obj.countyName;
        }
        this.defaultSelectCascader = str;
        this.form.locationquyu = str;
      }
      target.compType = obj.compType + "";
      target.taxpayerId = obj.taxpayerId + "";
      target.idType = "1";
      target.compClass = obj.compClass + "";
      this.clearCheck("default");

      if (target.unifiedCode) {
        this.uploadIsCheck = "no";
        this.$eventBus.$emit("isCheckFile", "no");
      } else {
        this.uploadIsCheck = "check";
        this.$eventBus.$emit("isCheckFile", "check");
      }
      obj.fileBos.forEach((item, idx) => {
        let fileBo = {
          name: "",
          url: "",
          percentage: 100,
          response: {
            data: [{}],
          },
        };
        fileBo.response.data[0].uploadId = item.uploadId;
        fileBo.response.data[0].fileAddress = item.fileAddress;
        fileBo.response.data[0].validityStart = item.validityStart;
        fileBo.response.data[0].validityEnd = item.validityEnd;
        fileBo.response.data[0].website = item.website;
        fileBo.response.data[0].isLongValidity = item.isLongValidity;
        fileBo.name = item.uploadId;
        fileBo.url = item.fileAddress;
        console.log(
          idx > this.titleData.length - 1,
          idx,
          this.titleData.length - 1,
          "数值"
        );
        if (idx > this.titleData.length - 1) {
          this.titleData2[idx - this.titleData.length].fileList = [fileBo];
        } else if (idx >= 2) {
          if (item.fileName !== "法定代表人身份证" && idx === 1) {
            this.titleData[idx + 1].fileList = [fileBo];
          }
          if (idx > 1) {
            this.titleData[idx].fileList = [fileBo];
          }
        } else {
          this.titleData[idx].fileList = [fileBo];
        }
      });
      this.isDefaultImg = false;
      this.$nextTick(() => {
        this.isDefaultImg = true;
      });
      console.log(this.titleData2, "titledata2");
      console.log(target.unifiedCode, obj, "过滤基本信息");
    },
    regNumber(name) {
      this.form[name] = this.form[name].replace(/[^\d.]/g, "");
    },
    regSpace(name) {
      this.form[name] = this.form[name].replace(/\s+/g, "");
    },
    // 区域选择
    cascaderChange(node) {
      this.cascaderArr.forEach((item) => {
        this.form[item.code] = "";
        this.form[item.name] = "";
      });
      if (node.length) {
        node.forEach((item, idx) => {
          let name = this.cascaderArr[idx].name;
          let code = this.cascaderArr[idx].code;
          this.form[code] = item.split("/")[0];
          this.form[name] = item.split("/")[1];
        });
      }
      console.log(node, this.form, "选择完");
    },
    // 查询区域
    getQryByCode(addressCode = "0", resolve) {
      getQryByCode({ code: addressCode }).then((res) => {
        if (res.data.code === "0") {
          try {
            res.data.data.forEach((item) => {
              item.value = item.code + "/" + item.name;
              item.label = item.name;
              item.leaf = item.level === 3;
            });
            if (!resolve) {
              this.options = res.data.data;
            } else {
              resolve(res.data.data);
            }
          } catch (e) {
            console.log(e, "error");
          }
        }
      });
    },
    //查询字典接口纳税人类型
    visibleChangeTax() {
      getQryDictByCode({ code: "TAXPAYER_TYPE" }).then((res) => {
        // console.log(res, "查询字典接口纳税人类型");
        if (res.data.code === "0") {
          this.taxerList = res.data.data;
        }
      });
    },
    //查询字典接口公司类型
    visibleChangeGslx() {
      getQryDictByCode({ code: "GSLX" }).then((res) => {
        console.log(res, "查询字典接口公司类型");
        if (res.data.code === "0") {
          this.codeList = res.data.data;
        }
      });
    },
    // 查询字典接口单位类别
    visibleChangeCompclass() {
      getQryDictByCode({ code: "COMPCLASS" }).then((res) => {
        console.log(res, "查询字典接口单位类别");
        if (res.data.code === "0") {
          this.COMPCLASSList = res.data.data;
        }
      });
    },
    //查询字典接口证件类型
    visibleChangeIDTYPE() {
      getQryDictByCode({ code: "IDTYPE" }).then((res) => {
        // console.log(res, "查询字典接口证件类型");
        if (res.data.code === "0") {
          this.IDList = res.data.data;
        }
      });
    },
    getQryBusinessInfo() {
      getQryBusinessInfo({
        compName: this.form.businessName,
        isShowLoading: true,
      })
        .then((res) => {
          if (res.data.code === "0" && res.data.data.businessName) {
            sessionStorage.setItem('businessId', res.data.data.businessId)

            this.showInfoModal = true;
            this.showInfoContent = this.$options.data().showInfoContent;
            if (res.data.data.compType == null) {
              res.data.data.compType = "";
            }
            if (res.data.data.compClass == null) {
              res.data.data.compClass = "";
            }
            if (res.data.data.taxpayerId == null) {
              res.data.data.taxpayerId = "";
            }
            this.copyBasicInfo(this.form, res.data.data);
            this.canEdit = !!res.data.data.flag;
            if (res.data.data.businessId) {
              this.businessId = res.data.data.businessId;
            }
          }
          if (
            res.data.code === "0" &&
            (res.data.data.businessName === undefined ||
              res.data.data.businessName === "")
          ) {
            sessionStorage.setItem('businessId', res.data.data.businessId)

            this.showInfoModal = true;
            this.showInfoContent =
              "申请开店需在注册开始时间8小时内完善后提交，否则注册信息删除。";
            getQryBusinessInfoByTyc({
              compName: this.form.businessName,
              isShowLoading: true,
            }).then((res) => {
              if (res.data.code === "0") {
                this.canEdit = !!res.data.data.businessShortName;
                this.copyInfoByTc(this.form, res.data.data);
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 根据名称查询联系人Id
    getQryByBusName() {
      getQryByBusName({ businessName: this.form.businessName }).then((res) => {
        console.log(res, "根据名称查询商家Id");
        if (res.data.code === "0") {
          if (!this.contactId) {
            this.contactId = res.data.data.contactId;
          }
        }
      });
    },
    mountedFn() {
      let getBusinessName = sessionStorage.getItem("businessName");
      if (this.reload) {
        this.deleteLoad();
        this.$router.replace("/business-open-shop/ready-data");
        return false;
      }
      this.$store.commit("RELOAD_SET", true);
      let getContactId = sessionStorage.getItem("contactId");
      this.form.businessName = getBusinessName;
      if (!getContactId) {
        this.getQryByBusName();
      } else {
        this.contactId = Number(getContactId);
      }
      this.getQryBusinessInfo();
      window.onbeforeunload = this.onbeforeunload;
      // window.addEventListener('beforeunload', e => this.onbeforeunload(e))
      this.visibleChangeGslx();
      this.visibleChangeCompclass();
      this.visibleChangeTax();
      this.visibleChangeIDTYPE();
      this.getQryByCode();
    },
    deleteLoad() {
      window.removeEventListener("beforeunload", (e) => this.onbeforeunload(e));
      //window.onbeforeunload = null
    },
    onbeforeunload(e) {
      e = e || window.event;
      // 兼容IE8和Firefox 4之前的版本
      if (e) {
        e.returnValue = "关闭提示";
      }
      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      return "关闭提示";
    },
    // 社会信用代码输入
    creditCodeChange(val) {
      if (val) {
        this.$eventBus.$emit("isCheckFile", "no");
      } else {
        this.$eventBus.$emit("isCheckFile", "check");
      }
      this.clearCheck();
    },
    crumbsBack() {
      this.dialogVisible = true;
    },
    // 提交接口
    getAddBusinessInfo(params) {
      params.concatId = this.contactId;
      getAddBusinessInfo(params).then((res) => {
        console.log(res, "提交接口");
        if (res.data.code === "0") {
          this.shopCode = res.data.data.shopCode;
          Cookies.set("shopCode", this.shopCode);
          this.businessId = res.data.data.businessId;
          sessionStorage.setItem("query", JSON.stringify(res.data.data));
          this.$router.replace({
            path:
              "/business-open-shop/apply-shop-info/" +
              this.$crypto.Encrypt(res.data.data.businessId + ""),
          });
          this.$store.dispatch("businessOpenShopSetStep", 4);
        }else {
          this.$message({
            showClose: true,
            type: "error",
            message: res.data.message,
            ccuiCustom: true,
          });
        }
      });
    },
    clearCheck(defaultVal) {
      let form = this.form;
      if (form.regNum && form.orgCode && form.taxCode && !form.unifiedCode) {
        this.rules.unifiedCode[0].required = false;
        this.isRules.forEach((item) => {
          this.rules[item][0].required = true;
        });
        if (!defaultVal) {
          this.$refs["form"].validateField("unifiedCode");
        }
        return false;
      }
      if (!form.regNum && !form.orgCode && !form.taxCode && !form.unifiedCode) {
        this.rules.unifiedCode[0].required = true;
        this.isRules.forEach((item) => {
          this.rules[item][0].required = false;
          if (!defaultVal) {
            this.$refs["form"].validateField(item);
          }
        });
        return false;
      }
      if (form.unifiedCode) {
        this.rules.unifiedCode[0].required = true;
        this.isRules.forEach((item) => {
          this.rules[item][0].required = false;
          if (!defaultVal) {
            this.$refs["form"].validateField(item);
          }
        });
        return false;
      }
      if (form.regNum || form.orgCode || form.taxCode) {
        this.rules.unifiedCode[0].required = false;
        this.isRules.forEach((item) => {
          this.rules[item][0].required = true;
        });
        if (!defaultVal) {
          this.$refs["form"].validateField("unifiedCode");
        }
        return false;
      }
    },
    // 下一步
    nextClick() {
      this.$eventBus.$emit("isCheck", "inputBusinessInfo");
      this.clearCheck();
      this.$refs["form"].validate();
      let submitParams = {
        fileBos: [],
        businessInfoBO: JSON.parse(JSON.stringify(this.form)),
        isShowLoading: true,
        businessResource: 1,
        loadingMessage: "保存中,请稍等...",
      };
      if (this.businessId + "") {
        submitParams.businessInfoBO.businessId = this.businessId;
      }
      console.log(this.contactId);
      delete submitParams.businessInfoBO.locationquyu;
      console.log(this.$refs.uploadTemplate, submitParams, "资质文件");
      this.$nextTick(() => {
        const errorFormEl = document.body.querySelectorAll(".is-error");
        if (!errorFormEl.length) {
          this.$refs.uploadTemplate.forEach((item) => {
            console.log("this.item", item);
            if (item.fileList.length) {
              submitParams.fileBos.push({
                isDefault: 1,
                fileName: item.titleData.name,
                uploadId: item.fileList[0].response.data[0].uploadId,
                fileAddress: item.fileList[0].response.data[0].fileAddress,
                website: item.form.website,
                uploadTime: item.fileList[0].response.data[0].createTime,
                validityStart: item.form.startTime,
                validityEnd: item.form.checked ? "" : item.form.endTime,
                isLongValidity: item.form.checked,
              });
            }
          });
          this.getAddBusinessInfo(submitParams);
        } else {
          document.documentElement.scrollTop = errorFormEl[0].offsetTop - 100;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.explain {
  display: inline-block;
  line-height: 16px;
  position: absolute;
  margin-left: 20px;
  color: #9b9b9b;
}
/deep/ .input-long {
  width: 410px;
}
/deep/ .checkClass {
  input::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #4a4a4a;
  }

  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #4a4a4a;
    opacity: 1;
  }

  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #4a4a4a;
    opacity: 1;
  }

  input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #4a4a4a;
  }
}
.ccui-app-container-detail2 {
  margin: 20px 0px 20px;
  padding: 21px 0px 0px;
}
.step-right-lyp {
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 16px;
}

.icon-delete {
  margin-top: 10px;
  margin-left: -33px;
  position: absolute;
  display: none;
  color: #909399;
  cursor: pointer;
}
/deep/ .el-cascader:hover + .icon-delete {
  display: inline-block;
  color: #909399;
}
.icon-delete:hover {
  display: inline-block;
  color: #909399;
}
</style>
